(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["h2d-character-shop"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '.h2d-cs-nav';
  let header, resizeObserver, mutationObserver, frame = 0, followUntil = 0;
  let navs = [];
  const update = () => {
    frame = 0;
    if (!navs.length) return;
    const style = header && getComputedStyle(header);
    const bottom = style && ['sticky', 'fixed'].includes(style.position)
      ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    const value = Math.ceil(bottom) + 'px';
    navs.forEach(nav => {
      if (nav.style.getPropertyValue('--cs-nav-offset') !== value) nav.style.setProperty('--cs-nav-offset', value);
    });
    if (performance.now() < followUntil) schedule();
  };
  const schedule = () => { if (!frame && navs.length) frame = requestAnimationFrame(update); };
  const followTransition = event => {
    if (event.target !== header) return;
    // Follow the header's animation only while it is moving, never poll at rest.
    followUntil = performance.now() + 1000;
    schedule();
  };
  const refresh = () => {
    navs = Array.from(document.querySelectorAll(selector));
    const nextHeader = document.querySelector('.section-header');
    if (nextHeader !== header) {
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
      header?.removeEventListener('transitionrun', followTransition);
      header = nextHeader;
      if (header) {
        resizeObserver = new ResizeObserver(schedule);
        resizeObserver.observe(header);
        mutationObserver = new MutationObserver(schedule);
        mutationObserver.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
        header.addEventListener('transitionrun', followTransition);
      }
    }
    schedule();
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', event => {
    navs = navs.filter(nav => !event.target.contains(nav));
    if (!navs.length) {
      resizeObserver?.disconnect(); mutationObserver?.disconnect();
      header?.removeEventListener('transitionrun', followTransition);
      header = null;
      cancelAnimationFrame(frame); frame = 0;
    }
  });
  refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h2d-favorites"] && !Shopify.designMode) return;
  try {
    
function initH2dFavorites(root) {
root.querySelectorAll('.h2d-favorites').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='true';
const track=section.querySelector('.h2d-favorites__track'),prev=section.querySelector('.h2d-favorites__prev'),next=section.querySelector('.h2d-favorites__next');
prev.hidden=false;next.hidden=false;
const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
const move=direction=>{const card=track.querySelector('li');if(!card)return;track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
track.addEventListener('scroll',update,{passive:true});
track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
const observer=new ResizeObserver(update);observer.observe(track);update();
const cleanup=e=>{if(e.target.contains(section)){observer.disconnect();document.removeEventListener('shopify:section:unload',cleanup);}};
document.addEventListener('shopify:section:unload',cleanup);
});
}
initH2dFavorites(document);
document.addEventListener('shopify:section:load',e=>initH2dFavorites(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h2d-gold-ring-product"]) return;
  try {
    
(()=>{const update=root=>{if(!root)return;const sizeOutput=root.querySelector('.h2d-mobile-current-size');if(sizeOutput){const fields=[...root.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input')];const field=fields.find(f=>/size|尺码|尺寸/i.test(f.querySelector('legend,label.form__label')?.textContent||''));const selected=field?.querySelector('input:checked,select');const value=selected?.value;if(value&&sizeOutput.textContent!==value)sizeOutput.textContent=value;}const output=root.querySelector('[data-engraving-preview]');const input=root.querySelector('[name="properties[Engraving Text]"]');if(!output||!input)return;if(!output.dataset.placeholder)output.dataset.placeholder=output.textContent;const previewText=input.value||output.dataset.placeholder;if(output.textContent!==previewText)output.textContent=previewText;const option=root.querySelector('[name="properties[Engraving Font]"]:checked');const optionNumber=option?option.value.replace('Option ',''):'1';output.dataset.option=optionNumber;root.querySelectorAll('[data-live-font-sample]').forEach(sample=>{sample.hidden=sample.dataset.liveFontSample!==optionNumber;});};document.addEventListener('input',e=>{if(e.target.matches('[name="properties[Engraving Text]"]'))update(e.target.closest('.h2d-rings'))});document.addEventListener('change',e=>{if(e.target.matches('[name="properties[Engraving Font]"]'))update(e.target.closest('.h2d-rings'))});document.addEventListener('shopify:section:load',()=>document.querySelectorAll('.h2d-rings').forEach(update));document.querySelectorAll('.h2d-rings').forEach(root=>{update(root);new MutationObserver(()=>update(root)).observe(root,{childList:true,subtree:true});root.addEventListener('change',()=>requestAnimationFrame(()=>update(root)));});document.addEventListener('click',e=>{const link=e.target.closest('.h2d-ring-guide a[href="#h2d-full-size"], .h2d-mobile-size-link');if(!link)return;const target=document.getElementById('h2d-full-size');if(!target)return;e.preventDefault();const h=document.querySelector('.section-header');const nav=document.querySelector('[data-ring-nav]');const offset=(h?Math.max(0,h.getBoundingClientRect().bottom):0)+(nav?nav.offsetHeight:0)+16;window.scrollTo({top:target.getBoundingClientRect().top+scrollY-offset,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});target.tabIndex=-1;target.focus({preventScroll:true});});const setupFontSlider=root=>{
const track=root.querySelector('[data-font-slider]'),pagination=root.querySelector('[data-font-pagination]'),previous=root.querySelector('[data-font-slider-previous]'),next=root.querySelector('[data-font-slider-next]');
if(!track||!pagination||!previous||!next||track.dataset.sliderReady)return;
track.dataset.sliderReady='true';
const items=[...track.querySelectorAll('label')], reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
let targets=[],frame=0,drag=null,suppressClick=false;
const max=()=>Math.max(0,track.scrollWidth-track.clientWidth);
const go=index=>track.scrollTo({left:targets[Math.max(0,Math.min(targets.length-1,index))]||0,behavior:reduced?'auto':'smooth'});
pagination.replaceChildren();
const dots=items.map((item,index)=>{const dot=document.createElement('button');dot.type='button';dot.className='h2d-font-slider__dot';dot.setAttribute('aria-label','Show font style '+(index+1));dot.addEventListener('click',()=>go(index));pagination.append(dot);return dot;});
const paint=()=>{frame=0;const end=max(),left=track.scrollLeft;const active=end?Math.round(Math.max(0,Math.min(1,left/end))*(items.length-1)):0;
dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===active);dot.setAttribute('aria-current',i===active?'true':'false');});
previous.classList.toggle('is-hidden',left<=2);previous.disabled=left<=2;
next.classList.toggle('is-hidden',left>=end-2);next.disabled=left>=end-2;
pagination.hidden=end<=2;
};
const update=()=>{if(!frame)frame=requestAnimationFrame(paint);};
const measure=()=>{targets=items.map((_,i)=>max()*i/Math.max(1,items.length-1));update();};
previous.addEventListener('click',()=>{const i=targets.findLastIndex(x=>x<track.scrollLeft-4);go(Math.max(0,i));});
next.addEventListener('click',()=>{const i=targets.findIndex(x=>x>track.scrollLeft+4);go(i<0?targets.length-1:i);});
track.addEventListener('dragstart',event=>event.preventDefault());
track.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0)return;suppressClick=false;drag={id:event.pointerId,x:event.clientX,left:track.scrollLeft,moved:false};});
track.addEventListener('pointermove',event=>{if(!drag||event.pointerId!==drag.id)return;const delta=event.clientX-drag.x;if(!drag.moved&&Math.abs(delta)<5)return;if(!drag.moved){drag.moved=true;track.setPointerCapture(event.pointerId);track.classList.add('is-dragging');}event.preventDefault();track.scrollLeft=drag.left-delta;});
const finish=event=>{if(!drag||event.pointerId!==drag.id)return;suppressClick=drag.moved;drag=null;track.classList.remove('is-dragging');if(track.hasPointerCapture(event.pointerId))track.releasePointerCapture(event.pointerId);};
track.addEventListener('pointerup',finish);track.addEventListener('pointercancel',finish);
track.addEventListener('lostpointercapture',()=>{drag=null;track.classList.remove('is-dragging');});
track.addEventListener('pointerleave',()=>{if(drag&&!drag.moved)drag=null;});
track.addEventListener('click',event=>{if(suppressClick){event.preventDefault();event.stopImmediatePropagation();suppressClick=false;}},true);
track.addEventListener('scroll',update,{passive:true});
const observer=new ResizeObserver(measure);observer.observe(track);
document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(track)){observer.disconnect();cancelAnimationFrame(frame);}},{once:true});
measure();
};document.querySelectorAll('.h2d-rings').forEach(setupFontSlider);document.addEventListener('shopify:section:load',event=>setupFontSlider(event.target.querySelector('.h2d-rings')||event.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h2d-his-world-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '.h2d-his-world__nav';
  let header, resizeObserver, mutationObserver, frame = 0, followUntil = 0;
  let navs = [];
  const update = () => {
    frame = 0;
    if (!navs.length) return;
    const style = header && getComputedStyle(header);
    const bottom = style && ['sticky', 'fixed'].includes(style.position)
      ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    const value = Math.ceil(bottom) + 'px';
    navs.forEach(nav => {
      if (nav.style.getPropertyValue('--h2d-nav-offset') !== value) nav.style.setProperty('--h2d-nav-offset', value);
    });
    if (performance.now() < followUntil) schedule();
  };
  const schedule = () => { if (!frame && navs.length) frame = requestAnimationFrame(update); };
  const followTransition = event => {
    if (event.target !== header) return;
    // Follow the header's animation only while it is moving, never poll at rest.
    followUntil = performance.now() + 1000;
    schedule();
  };
  const refresh = () => {
    navs = Array.from(document.querySelectorAll(selector));
    const nextHeader = document.querySelector('.section-header');
    if (nextHeader !== header) {
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
      header?.removeEventListener('transitionrun', followTransition);
      header = nextHeader;
      if (header) {
        resizeObserver = new ResizeObserver(schedule);
        resizeObserver.observe(header);
        mutationObserver = new MutationObserver(schedule);
        mutationObserver.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
        header.addEventListener('transitionrun', followTransition);
      }
    }
    schedule();
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', event => {
    navs = navs.filter(nav => !event.target.contains(nav));
    if (!navs.length) {
      resizeObserver?.disconnect(); mutationObserver?.disconnect();
      header?.removeEventListener('transitionrun', followTransition);
      header = null;
      cancelAnimationFrame(frame); frame = 0;
    }
  });
  refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h2d-product-detail-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{let button=event.target.closest('[data-unit]');if(!button)return;let panel=button.closest('[data-h2d-details]');if(!panel)return;let inches=button.dataset.unit==='in';panel.querySelectorAll('[data-mm]').forEach(cell=>{cell.textContent=inches?(Number(cell.dataset.mm)/25.4).toFixed(3):cell.dataset.mm});panel.querySelectorAll('[data-unit-name]').forEach(el=>el.textContent=inches?'in':'mm');panel.querySelectorAll('[data-unit]').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h2d-product-detail-nav"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('[data-ring-nav] a');if(!link)return;const target=document.getElementById(link.hash.slice(1));if(!target)return;event.preventDefault();const header=document.querySelector('.section-header');const navHeight=link.closest('[data-ring-nav]').getBoundingClientRect().height;const offset=(header?Math.max(0,header.getBoundingClientRect().bottom):0)+navHeight+16;window.scrollTo({top:target.getBoundingClientRect().top+window.scrollY-offset,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});document.querySelectorAll('[data-ring-nav] a').forEach(a=>a.removeAttribute('aria-current'));link.setAttribute('aria-current','location');target.setAttribute('tabindex','-1');target.focus({preventScroll:true});});

(()=>{let queued=false;const updateHeader=()=>{const h=document.querySelector('.section-header');const top=h?Math.max(0,h.getBoundingClientRect().bottom):0;document.documentElement.style.setProperty('--h2d-header-bottom',top+'px');const nav=document.querySelector('[data-ring-nav]');const end=document.getElementById('h2d-warranty');if(nav&&end)nav.closest('.shopify-section').classList.toggle('h2d-nav-past-details',end.getBoundingClientRect().bottom<=top+nav.offsetHeight)};const initReviews=()=>{if(!document.querySelector('[data-ring-nav]'))return;document.querySelectorAll('.jdgm-rev__body:not([data-h2d-fold])').forEach(body=>{if(!body.textContent.trim())return;body.dataset.h2dFold='true';const line=parseFloat(getComputedStyle(body).lineHeight)||24;if(body.scrollHeight<=line*2.1&&body.textContent.trim().length<100)return;body.classList.add('h2d-review-collapsed');body.id=body.id||'h2d-review-'+Math.random().toString(36).slice(2);const button=document.createElement('button');button.type='button';button.className='h2d-review-toggle';button.textContent='Read more';button.setAttribute('aria-expanded','false');button.setAttribute('aria-controls',body.id);body.after(button)});};const update=()=>{queued=false;updateHeader();initReviews()};const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update)}};new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});window.addEventListener('scroll',updateHeader,{passive:true});window.addEventListener('resize',schedule);document.addEventListener('shopify:section:load',schedule);document.addEventListener('click',event=>{const button=event.target.closest('.h2d-review-toggle');if(!button)return;const body=document.getElementById(button.getAttribute('aria-controls'));if(!body)return;const expanded=button.getAttribute('aria-expanded')==='true';body.classList.toggle('h2d-review-collapsed',expanded);button.setAttribute('aria-expanded',String(!expanded));button.textContent=expanded?'Read more':'Show less'});update();})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h2d-rings-product"]) return;
  try {
    
(()=>{const update=root=>{if(!root)return;const sizeOutput=root.querySelector('.h2d-mobile-current-size');if(sizeOutput){const fields=[...root.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input')];const field=fields.find(f=>/size|尺码|尺寸/i.test(f.querySelector('legend,label.form__label')?.textContent||''));const selected=field?.querySelector('input:checked,select');const value=selected?.value;if(value&&sizeOutput.textContent!==value)sizeOutput.textContent=value;}const output=root.querySelector('[data-engraving-preview]');const input=root.querySelector('[name="properties[Engraving Text]"]');if(!output||!input)return;if(!output.dataset.placeholder)output.dataset.placeholder=output.textContent;const previewText=input.value||output.dataset.placeholder;if(output.textContent!==previewText)output.textContent=previewText;const option=root.querySelector('[name="properties[Engraving Font]"]:checked');const optionNumber=option?option.value.replace('Option ',''):'1';output.dataset.option=optionNumber;root.querySelectorAll('[data-live-font-sample]').forEach(sample=>{sample.hidden=sample.dataset.liveFontSample!==optionNumber;});};document.addEventListener('input',e=>{if(e.target.matches('[name="properties[Engraving Text]"]'))update(e.target.closest('.h2d-rings'))});document.addEventListener('change',e=>{if(e.target.matches('[name="properties[Engraving Font]"]'))update(e.target.closest('.h2d-rings'))});document.addEventListener('shopify:section:load',()=>document.querySelectorAll('.h2d-rings').forEach(update));document.querySelectorAll('.h2d-rings').forEach(root=>{update(root);new MutationObserver(()=>update(root)).observe(root,{childList:true,subtree:true});root.addEventListener('change',()=>requestAnimationFrame(()=>update(root)));});document.addEventListener('click',e=>{const link=e.target.closest('.h2d-ring-guide a[href="#h2d-full-size"], .h2d-mobile-size-link');if(!link)return;const target=document.getElementById('h2d-full-size');if(!target)return;e.preventDefault();const h=document.querySelector('.section-header');const nav=document.querySelector('[data-ring-nav]');const offset=(h?Math.max(0,h.getBoundingClientRect().bottom):0)+(nav?nav.offsetHeight:0)+16;window.scrollTo({top:target.getBoundingClientRect().top+scrollY-offset,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});target.tabIndex=-1;target.focus({preventScroll:true});});const setupFontSlider=root=>{
const track=root.querySelector('[data-font-slider]'),pagination=root.querySelector('[data-font-pagination]'),previous=root.querySelector('[data-font-slider-previous]'),next=root.querySelector('[data-font-slider-next]');
if(!track||!pagination||!previous||!next||track.dataset.sliderReady)return;
track.dataset.sliderReady='true';
const items=[...track.querySelectorAll('label')], reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
let targets=[],frame=0,drag=null,suppressClick=false;
const max=()=>Math.max(0,track.scrollWidth-track.clientWidth);
const go=index=>track.scrollTo({left:targets[Math.max(0,Math.min(targets.length-1,index))]||0,behavior:reduced?'auto':'smooth'});
pagination.replaceChildren();
const dots=items.map((item,index)=>{const dot=document.createElement('button');dot.type='button';dot.className='h2d-font-slider__dot';dot.setAttribute('aria-label','Show font style '+(index+1));dot.addEventListener('click',()=>go(index));pagination.append(dot);return dot;});
const paint=()=>{frame=0;const end=max(),left=track.scrollLeft;const active=end?Math.round(Math.max(0,Math.min(1,left/end))*(items.length-1)):0;
dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===active);dot.setAttribute('aria-current',i===active?'true':'false');});
previous.classList.toggle('is-hidden',left<=2);previous.disabled=left<=2;
next.classList.toggle('is-hidden',left>=end-2);next.disabled=left>=end-2;
pagination.hidden=end<=2;
};
const update=()=>{if(!frame)frame=requestAnimationFrame(paint);};
const measure=()=>{targets=items.map((_,i)=>max()*i/Math.max(1,items.length-1));update();};
previous.addEventListener('click',()=>{const i=targets.findLastIndex(x=>x<track.scrollLeft-4);go(Math.max(0,i));});
next.addEventListener('click',()=>{const i=targets.findIndex(x=>x>track.scrollLeft+4);go(i<0?targets.length-1:i);});
track.addEventListener('dragstart',event=>event.preventDefault());
track.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0)return;suppressClick=false;drag={id:event.pointerId,x:event.clientX,left:track.scrollLeft,moved:false};});
track.addEventListener('pointermove',event=>{if(!drag||event.pointerId!==drag.id)return;const delta=event.clientX-drag.x;if(!drag.moved&&Math.abs(delta)<5)return;if(!drag.moved){drag.moved=true;track.setPointerCapture(event.pointerId);track.classList.add('is-dragging');}event.preventDefault();track.scrollLeft=drag.left-delta;});
const finish=event=>{if(!drag||event.pointerId!==drag.id)return;suppressClick=drag.moved;drag=null;track.classList.remove('is-dragging');if(track.hasPointerCapture(event.pointerId))track.releasePointerCapture(event.pointerId);};
track.addEventListener('pointerup',finish);track.addEventListener('pointercancel',finish);
track.addEventListener('lostpointercapture',()=>{drag=null;track.classList.remove('is-dragging');});
track.addEventListener('pointerleave',()=>{if(drag&&!drag.moved)drag=null;});
track.addEventListener('click',event=>{if(suppressClick){event.preventDefault();event.stopImmediatePropagation();suppressClick=false;}},true);
track.addEventListener('scroll',update,{passive:true});
const observer=new ResizeObserver(measure);observer.observe(track);
document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(track)){observer.disconnect();cancelAnimationFrame(frame);}},{once:true});
measure();
};document.querySelectorAll('.h2d-rings').forEach(setupFontSlider);document.addEventListener('shopify:section:load',event=>setupFontSlider(event.target.querySelector('.h2d-rings')||event.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h2d-video-hero"] && !Shopify.designMode) return;
  try {
    
function initH2dHero(root) {
  root.querySelectorAll('.h2d-hero').forEach(hero => {
    if (hero.dataset.ready) return;
    hero.dataset.ready = 'true';
    const media = hero.querySelector('.h2d-hero__media'), button = hero.querySelector('button');
    if (!button) return;
    const breakpoint = matchMedia('(max-width: 749px)');
    let video, disposed = false, visible = false, posterReady = false, startTimer;
    const poster = media.querySelector('img');
    const sync = () => { button.textContent = !video || video.paused ? button.dataset.play : button.dataset.pause; button.setAttribute('aria-label', button.textContent); };
    const mount = () => {
      if (video) { video.pause(); video.remove(); }
      const variant = breakpoint.matches ? 'mobile' : 'desktop';
      const source = media.querySelector('template[data-hero-video="' + variant + '"]');
      if (!source) return;
      media.append(source.content.cloneNode(true));
      video = media.querySelector('video');
      hero.dataset.videoVariant = variant;
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData) video.play().catch(sync);
      sync();
    };
    const startWhenReady = () => {
      if (disposed || !visible || !posterReady || video || startTimer) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
      // Give the poster a paint opportunity before requesting video bytes.
      startTimer = setTimeout(() => { startTimer = null; if (!disposed && visible && !video) mount(); }, 250);
    };
    const onPosterReady = () => { posterReady = true; startWhenReady(); };
    if (!poster || poster.complete) posterReady = true;
    else { poster.addEventListener('load', onPosterReady, { once: true }); poster.addEventListener('error', onPosterReady, { once: true }); }
    button.addEventListener('click', () => {
      if (!video) { mount(); video?.play().catch(sync); }
      else if (video.paused) video.play().catch(sync); else video.pause();
    });
    const onBreakpoint = () => { if (video) mount(); else startWhenReady(); };
    breakpoint.addEventListener('change', onBreakpoint);
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (!visible && video) video.pause();
      startWhenReady();
    });
    observer.observe(hero);
    const cleanup = event => {
      if (!event.target.contains(hero)) return;
      disposed = true; clearTimeout(startTimer);
      poster?.removeEventListener('load', onPosterReady); poster?.removeEventListener('error', onPosterReady);
      video?.pause(); observer.disconnect(); breakpoint.removeEventListener('change', onBreakpoint);
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
  });
}
initH2dHero(document);
document.addEventListener('shopify:section:load', event => initH2dHero(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
